import { socket } from "../index";

const emitGetUserDetails = (
  userIdList: string[]
) => {
  socket?.emit('GET_USERS_DETAIL', { userIdList });
}

export default emitGetUserDetails;